import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const activeParty = (state) => {

  return axios.get(API + "parties/party-active/"+state+"/",{headers: authHeader()});
};
const ActivePartyService = {
    activeParty,
  };
  export default ActivePartyService;